import React from 'react';
import { FlexColumn, FlexRow, OutlinedButton } from '@make-software/tg-mini-app-ui';

import {
  ProjectIndex,
  ProjectIndexText,
  ProjectLogo,
  ProjectLogoContainer,
  ProjectTitle
} from '@/shared';
import { openLink } from '@/utils';
import { IHackathonProject } from '@/entities';

interface IProjectHeaderProps extends IHackathonProject {
  rank?: number;
}

const getThumbUrl = (projectLogo?: IHackathonProject['project_logo']) =>
  projectLogo?.formats?.thumbnail?.url ?? projectLogo?.url ?? '';

export const ProjectHeader: React.FC<IProjectHeaderProps> = ({
  project_logo,
  title,
  project_link,
  rank
}) => {
  const thumb = getThumbUrl(project_logo);

  return (
    <FlexRow gap={10} align="center">
      {!!thumb && (
        <ProjectLogoContainer>
          <ProjectLogo src={thumb} />
        </ProjectLogoContainer>
      )}

      <FlexColumn gap={10}>
        <FlexRow gap={8} align="center">
          <ProjectIndex>
            <ProjectIndexText weight={3} size="lg">
              #{rank}
            </ProjectIndexText>
          </ProjectIndex>
          <ProjectTitle weight={3} size="lg" color="#FFFFFF">
            {title ?? 'Untitled'}
          </ProjectTitle>
        </FlexRow>

        {!!project_link && (
          <OutlinedButton
            title="View on DoraHacks"
            width="100%"
            height={25}
            onClick={openLink(project_link)}
            fontFamily="Inter"
            fontSize="12px"
            fontWeight={400}
          />
        )}
      </FlexColumn>
    </FlexRow>
  );
};
